import type VectorLayer from 'ol/layer/Vector'
import type VectorSource from 'ol/source/Vector'

import { createNonBlockingRenderByTime } from '../../../renderingQueue'
import { findFeature } from '../../findFeature'
import { setLayerMetadata } from '../../layerMetadata'

import { createRoadSegmentFeature } from './createRoadSegmentFeature'
import { findRoadSegmentMarker } from './findRoadSegmentMarker'
import { updateRoadSegmentFeature } from './updateRoadSegmentFeature'

const nonblockingRender = createNonBlockingRenderByTime()

/**
 * Update the rendered style and position for all the RoadSegments marked to be updated in a Changelog coming form the data-layer
 */
export async function changelogUpdateRoadSegmentFeatures(
  layer: VectorLayer<VectorSource>,
  roadSegments: uui.domain.ui.map.markers.MapMarkers['roadSegment'],
  mapStyles: uui.domain.ui.map.markers.MapStyles['roadSegment'],
  selection: Set<string>,
  roadSegmentIds: IterableIterator<string>,
) {
  nonblockingRender.reset()

  for (const roadSegmentId of roadSegmentIds) {
    await nonblockingRender.next()

    const marker = findRoadSegmentMarker(roadSegments, roadSegmentId)
    const feature = findFeature(layer, marker.id)
    const selected = selection.has(roadSegmentId)

    if (feature) {
      updateRoadSegmentFeature(mapStyles, marker, feature, selected)
    } else {
      layer.getSource()?.addFeature(createRoadSegmentFeature(marker, mapStyles, selected))
    }
  }

  // update the stored collection
  setLayerMetadata(layer, 'selection', selection)
}
